module.exports = __webpack_public_path__ + "img/s-mob-6.e2f9e1a7.webp";